import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ClaimRow } from '../../../models/api/view/claim-view/claim-row';
import { LeaveClaimSummaryInfo } from '../../../models/api/view/claim/summary/leaveclaimsummaryinfo';
import { BaseComponent } from '../../base/base.component';

@Component({
  selector: 'app-leave-schedule',
  imports: [CommonModule],
  template: `
    <div class="tw-hidden sm:tw-block">
      <table class="tw-w-full tw-text-center" tabindex="0">
        <caption class="tw-sr-only">Schedule (hours)</caption>
        <thead>
          <tr
            class="tw-font-bold tw-pb-2 xtw-border-b xtw-text-[var(--sed-black-60-color)] tw-bg-[var(--sed-open-grey-color)]"
          >
            <th
              scope="col"
              class="tw-text-left tw-py-1 xtw-text-[var(--sed-engaged-black-color)] tw-pl-2"
            >
              Schedule (hours)
            </th>

            @for (label of dayLabels; track label) {
              <th scope="col">{{ label }}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (week of weeks; track $index; let i = $index) {
            <tr [class.schedule-section-divider]="i === 2">
              <th
                scope="row"
                class="tw-font-bold tw-text-left tw-text-[var(--sed-black-80-color)] tw-py-1.5 tw-pl-2"
              >
                {{ week.label }} - {{ week.normal ? 'Normal' : 'Absence' }}
              </th>

              @for (day of week.days; track $index) {
                <td class="tw-text-center">
                  @if (day === 0) {
                    <div
                      class="tw-rounded-full tw-size-10 tw-flex tw-items-center tw-justify-center tw-m-auto tw-text-[var(--sed-black-80-color)]"
                    >
                      <span>{{ day | number: '1.0-2' }}</span>
                    </div>
                  } @else {
                    <div
                      class="tw-rounded-full tw-size-10 tw-flex tw-items-center tw-justify-center tw-font-bold tw-bg-[var(--sed-open-grey-color)] tw-m-auto"
                    >
                      <span>{{ day | number: '1.0-2' }}</span>
                    </div>
                  }
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="sm:tw-hidden" tabindex="0" role="region" aria-label="Schedule (hours)">
      <div class="tw-font-bold tw-pb-2">Schedule (hours)</div>
      @for (week of weeks; track $index; let i = $index) {
        <div class="tw-py-2 tw-border-b tw-border-[var(--sed-grey-40-color)] last:tw-border-b-0">
          <div class="tw-font-bold tw-pb-1">
            {{ week.label }} - {{ week.normal ? 'Normal' : 'Absence' }}
          </div>
          @for (day of week.days; track $index; let dayIdx = $index) {
            <div class="tw-flex tw-justify-between tw-py-1" [class.tw-font-bold]="dayIdx === 7">
              <span>{{ dayIdx === 7 ? 'Total' : dayLabels[dayIdx] }}</span>
              @if (day === 0) {
                <span class="tw-text-[var(--sed-black-80-color)]">{{ day | number: '1.0-2' }}</span>
              } @else {
                <span class="tw-font-bold">{{ day | number: '1.0-2' }}</span>
              }
            </div>
          }
        </div>
      }
    </div>
  `,
  styles: `
    td,
    th {
      vertical-align: middle;
    }

    .schedule-section-divider > th,
    .schedule-section-divider > td {
      border-top: 1px solid var(--sed-grey-40-color);
    }
  `,
})
export class LeaveScheduleComponent extends BaseComponent implements OnInit {
  /**
   *
   */
  constructor() {
    super();
    // let week = new Week();
    // week.label = 'Week 1';
    // week.normal = true;
    // this.weeks.push(week);

    // week = new Week();
    // week.label = 'Week 1';
    // week.normal = false;
    // week.mon = 0;
    // week.tue = 0;
    // week.tot = 24;
    // this.weeks.push(week);

    // week = new Week();
    // week.label = 'Week 2';
    // week.normal = true;
    // this.weeks.push(week);

    // week = new Week();
    // week.label = 'Week 2';
    // week.normal = false;
    // week.mon = 0;
    // week.tue = 0;
    // week.tot = 24;
    // this.weeks.push(week);
  }
  readonly dayLabels = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Tot'];

  claimRow: ClaimRow;
  leaveClaimSummaryInfo: LeaveClaimSummaryInfo;
  weeks: Week[] = [];

  async ngOnInit(): Promise<void> {
    this.claimRow = this.view.currentClaim();

    if (this.claimRow.lineOfBusiness === 'LA') {
      this.leaveClaimSummaryInfo =
        await this.api.claimSummary.getLeaveClaimSummaryInfo(
          this.claimRow.recordSource,
          this.claimRow.recordId,
        );
      if (this.leaveClaimSummaryInfo && this.leaveClaimSummaryInfo.schedule) {
        this.leaveClaimSummaryInfo.schedule.forEach((week) => {
          const weekNormal = new Week();
          weekNormal.label = `Week ${week.weekNumber}`;
          weekNormal.normal = true;
          weekNormal.sun = week.normalWeek.sunday ?? 0;
          weekNormal.mon = week.normalWeek.monday ?? 0;
          weekNormal.tue = week.normalWeek.tuesday ?? 0;
          weekNormal.wed = week.normalWeek.wednesday ?? 0;
          weekNormal.thu = week.normalWeek.thursday ?? 0;
          weekNormal.fri = week.normalWeek.friday ?? 0;
          weekNormal.sat = week.normalWeek.saturday ?? 0;
          weekNormal.tot =
            weekNormal.sun +
            weekNormal.mon +
            weekNormal.tue +
            weekNormal.wed +
            weekNormal.thu +
            weekNormal.fri +
            weekNormal.sat;
          this.weeks.push(weekNormal);

          const weekAbsence = new Week();
          weekAbsence.label = `Week ${week.weekNumber}`;
          weekAbsence.normal = false;
          weekAbsence.sun = week.absenceWeek.sunday ?? 0;
          weekAbsence.mon = week.absenceWeek.monday ?? 0;
          weekAbsence.tue = week.absenceWeek.tuesday ?? 0;
          weekAbsence.wed = week.absenceWeek.wednesday ?? 0;
          weekAbsence.thu = week.absenceWeek.thursday ?? 0;
          weekAbsence.fri = week.absenceWeek.friday ?? 0;
          weekAbsence.sat = week.absenceWeek.saturday ?? 0;
          weekAbsence.tot =
            weekAbsence.sun +
            weekAbsence.mon +
            weekAbsence.tue +
            weekAbsence.wed +
            weekAbsence.thu +
            weekAbsence.fri +
            weekAbsence.sat;
          this.weeks.push(weekAbsence);
        });
      }
    }
  }
}

class Week {
  label: string;
  normal = true;
  sun?: number = 0;
  mon?: number = 0;
  tue?: number = 0;
  wed?: number = 0;
  thu?: number = 0;
  fri?: number = 0;
  sat?: number = 0;
  tot?: number = 0;

  get days(): number[] {
    return [
      this.sun,
      this.mon,
      this.tue,
      this.wed,
      this.thu,
      this.fri,
      this.sat,
      this.tot,
    ];
  }
}
